
import React from "react";
import { Button } from "@/components/ui/button";

interface FormActionsProps {
  onCancel: () => void;
  isSubmitting: boolean;
  isEditMode: boolean;
}

const FormActions = ({ onCancel, isSubmitting, isEditMode }: FormActionsProps) => {
  return (
    <div className="flex justify-end space-x-2 pt-4">
      <Button type="button" variant="outline" onClick={onCancel}>
        Annuleren
      </Button>
      <Button type="submit" disabled={isSubmitting}>
        {isSubmitting ? "Bezig met opslaan..." : isEditMode ? "Wijzigen" : "Toevoegen"}
      </Button>
    </div>
  );
};

export default FormActions;
